import { Locale } from 'modules/i18n';

export default {
  [Locale.en]: {
    lowBalance: 'Low balance!',
    topUpYourAccount: 'Please, top up your account.',
    topUp: 'Top Up',
  },
};
